export default "/assets/images/mila-air-specs.a97569ce055a43d4.png";